// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__gv8qo","colMin":"styles_colMin__3IAIV","colCheckbox":"styles_colCheckbox__5gpau"};